import { initializePack } from "lib/shared/packs";
import detectUserInput from "initializers/detectUserInput";
import events from "initializers/events";
import view from "initializers/view";

initializePack({
  components: require.context(
    "components",
    true,
    // eslint-disable-next-line max-len
    /^\.\/(payments|sell\/|testimonials|groups\/|shared\/(Checkbox|Radio|Input|AppBanner|GoogleAuthButton|FacebookLoginButton|Banner|Select|SessionTimeoutModal|BirthdayInput|SignUpWithModal|Toaster|dialogs\/CookieOptIn))/
  ),
  initializers: [detectUserInput, events, view]
});
